export default __webpack_public_path__ + "static/media/bg-arrow.43618452.svg";